import { getServerSideProps as getServerSidePropsBrandPage } from 'modules/search-page/shared';
import { SearchPageProps } from 'modules/search-page/desktop';
import {
  getServerSidePropsBlockPage,
  BlockPageProps,
} from 'modules/block-page/shared';
import dynamic from 'next/dynamic';
import { useGlobalData } from 'contexts';
import { useRouter } from 'next/router';
import { t } from 'i18n';
import { HeadSectionProps } from 'components/HeadSection';

const BlockPage = dynamic(() =>
  import('modules/block-page/desktop').then((mod) => mod.BlockPage),
);

const SearchPage = dynamic(() =>
  import('modules/search-page/desktop').then((mod) => mod.SearchPage),
);

export const getServerSideProps: GetServerSideProps = ((context) =>
  !context?.req?.tenantEnv?.epicPb1887
    ? getServerSidePropsBlockPage(context)
    : getServerSidePropsBrandPage(context)) as GetServerSideProps;

const BrandPage: React.FC<SearchPageProps | BlockPageProps> = ({
  seoInfo,
  ...props
}) => {
  const { baseDomain, epicPb1887, canonicalDomain } = useGlobalData();
  const router = useRouter();
  const { query } = router;

  const brandName = (query.brandId as string).toUpperCase();

  const hasbrandDescription =
    t('brandPageDescription') !== 'brandPageDescription';

  const hasConfigBrandTitle = t('brandPageTitle') !== 'brandPageTitle';

  let canonical: string | undefined;
  if (seoInfo?.canonical) {
    if (canonicalDomain) {
      canonical = `${canonicalDomain}${seoInfo.canonical}`;
    } else if (baseDomain) {
      canonical = `${baseDomain}${seoInfo.canonical}`;
    }
  }

  const pageSeoInfo: HeadSectionProps = {
    metaTitle: hasConfigBrandTitle
      ? t('brandPageTitle', { brandName })
      : seoInfo?.metaTitle,

    description: hasbrandDescription
      ? t('brandPageDescription', { brandName })
      : seoInfo?.metaDescription,
    canonical,
    keywords: seoInfo?.metaKeywords,
  };

  const pageProps = {
    ...props,
    seoInfo: pageSeoInfo,
  };

  return !epicPb1887 ? (
    <BlockPage {...(pageProps as BlockPageProps)} />
  ) : (
    <SearchPage {...(pageProps as SearchPageProps)} />
  );
};

export default BrandPage;
